
import axios from "../api/index"
interface Request {
  username: string
  password: string
}
export const updateSuperUser = async (company: Request, user: string) => {
  const response = await axios.put("/admin/setuser", {fabrica: company , usuario: user} )
  return response
}